export default __webpack_public_path__ + "static/media/sunset_sand.81aa401e.jpg";